module.exports = __webpack_public_path__ + "assets/img/Logitech-VC-3-Australia-Landing-Page.66350f53.webp";